module.exports = __webpack_public_path__ + "img/37.1e7b98b5.png";